import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class BikeService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getJobCardForBike(bikeId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/Bike/' + bikeId + '/GetJobCards', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceHistoryForBike(bikeId: string, customerId: string) {
    const partnerId = this.helpersService.getPartnerId();
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        '/workshop/' + partnerId + '/customers/' + customerId + '/items/' + bikeId + '/history?code=' +
        this.env.key,
        headers
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getBike(bikeId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    if (bikeId === '' || bikeId === null || bikeId === undefined) {
      return throwError('Bike ID is invalid');
    }

    return this.http
      .get(this.apiURL + '/api/Bike/' + bikeId, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveBike(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http.post(this.apiURL + '/api/Bike', data, requestOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((res: any) => {
        return throwError(res.json());
      }),
    );
  }

  bikeSale(bike) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/v2.0/Athlete/Bikes/Sale?code=' + this.env.key,
        bike,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getBikeDetails(sku) {
    const partnerId = this.helpersService.getPartnerId();
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        '/Bikes/Details?code=' +
        this.env.key +
        '&Sku=' +
        sku +
        '&PartnerId=' +
        partnerId,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getActiveGear(bikeId: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        '/v3.0/Athlete/Bikes/Components?code=' +
        this.env.key +
        '&BikeID=' +
        bikeId,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );

    //let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    //return this.http
    //  .get(this.apiURL + '/api/Bike/' + bikeId + '/activegear', requestOptions)
    //  .pipe(
    //    map((res: any) => {return res;}),
    //    catchError((res: any) => {
    //      return throwError(res.json());
    //    })
    //  );
  }


  getItemBySerialNumber(partnerId: number, serialNumber: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + '/workshop/'+partnerId+'/items/serialNumber/' + serialNumber + '?code=' + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveGear(data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    if (data.ID > 0) {
      return this.http
        .put(
          this.env.url + '/Athlete/Bikes/Components?code=' + this.env.key,
          data,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res.json());
          }),
        );
    } else {
      return this.http
        .post(
          this.env.url + '/Athlete/Bikes/Components?code=' + this.env.key,
          data,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res.json());
          }),
        );
    }

    //let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    //return this.http.post(this.apiURL + '/api/Gear', data, requestOptions).pipe(
    //  map((res: any) => {return res;}),
    //  catchError((res: any) => {
    //    return throwError(res.json());
    //  })
    //);
  }

  retireGear(gearId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + `/api/Gear/${gearId}/Deactivate`, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceLogs(bikeId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/Bike/' + bikeId + '/GetJobCards', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  captureService(body: object) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    //TOTO what does body look like???
    return this.http
      .post(this.apiURL + '/api/Bike/CaptureService', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
